var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"companies"},[_c('SectionHeader',{scopedSlots:_vm._u([{key:"breadcrumbs",fn:function(){return [_c('BreadCrumbs',{attrs:{"items":[
          { text: _vm.$t('meta.sites'), name: 'company_sites' },
          { text: _vm.area && _vm.area.site.name, name: 'site', params: { site_uuid: _vm.$route.params.site_uuid } },
          {
            text: _vm.area && _vm.area.name,
            name: 'area',
            params: { site_uuid: _vm.$route.params.site_uuid, area_uuid: _vm.$route.params.area_uuid },
          },
          { text: _vm.$t('zones.createZone') } ]}})]},proxy:true}])}),_c('div',{staticClass:"body-content cf"},[_c('CompanyNav'),_c('div',{staticClass:"body"},[(_vm.loading)?_c('LoadingSpinner'):_c('ZoneForm',{attrs:{"site":_vm.area.site,"area":_vm.area},on:{"submit":_vm.createZone}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }